import type { WireArticle } from '../api/types'
import type { WireUser } from '../auth/useWireAuth'

/**
 * Evaluates whether a user lacks access to an article based on ABAC topic/region grants.
 *
 * Mirrors the backend permissive check:
 *   - If the article carries no topics → topics pass.
 *   - If the article carries topics, the user must have ≥1 matching topic.
 *   - If the article carries no regions → regions pass.
 *   - If the article carries regions, the user must have ≥1 matching region.
 *   - A deny on EITHER axis = locked.
 */
export function isArticleLocked(article: WireArticle, user: WireUser): boolean {
  if (article.topics?.length) {
    if (!article.topics.some(t => user.topics.includes(t))) return true
  }
  if (article.regions?.length) {
    if (!article.regions.some(r => user.regions.includes(r))) return true
  }
  return false
}
